import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    weeks: {
      type: Number,
      "default": 0
    },
    defaultTenantId: {
      type: String,
      "default": ''
    },
    tenantList: {
      type: Array,
      "default": []
    }
  },
  mounted: function mounted() {
    if (this.weeks != 0) {
      this.getTargetData();
    }
  },
  data: function data() {
    return {
      weekDataList: {},
      targetDataList: [],
      isLoadingTargetData: false,
      currentPage: 1,
      valueType: "percentage",
      tenantId: this.defaultTenantId
    };
  },
  methods: {
    pageChange: function pageChange(current_page) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.currentPage = current_page;
                _this.getTargetData();
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTargetData: function getTargetData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoadingTargetData = true;
                _this2.weekDataList = [];
                _context2.next = 4;
                return axios.post('/target/get_campaign_data', {
                  tenantId: _this2.tenantId,
                  page: _this2.currentPage,
                  valueType: _this2.valueType
                });
              case 4:
                res = _context2.sent;
                if (res.data.status == 'success') {
                  _this2.weekDataList = res.data.weekDataList;
                  _this2.targetDataList = res.data.targetDataList;
                }
                _this2.isLoadingTargetData = false;
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};